const MEASUREMENT_ID = import.meta.env.VITE_GA_MEASUREMENT_ID

/** Clave en localStorage para el consentimiento de cookies (valores: 'accepted' | 'rejected'). */
export const COOKIE_CONSENT_KEY = 'watchstreak_cookie_consent'

function buildGtagConfig() {
  // transport_url debe ser el ORIGEN (ej: "https://watchstreak.com").
  // gtag.js añade "/g/collect" automáticamente al enviarlo.
  // Usamos window.location.origin para que funcione en local y producción sin config extra.
  const origin = typeof window !== 'undefined' ? window.location.origin : ''
  return {
    // SPA: enviamos page_view manual (router + inicial) para evitar doble conteo.
    send_page_view: false,
    anonymize_ip: true,
    ...(origin ? { transport_url: origin } : {}),
  }
}

function applyConfig() {
  if (!MEASUREMENT_ID || typeof window === 'undefined' || typeof window.gtag !== 'function') return
  window.gtag('config', MEASUREMENT_ID, buildGtagConfig())
}

export function initAnalytics() {
  if (!MEASUREMENT_ID || typeof window === 'undefined') return

  window.dataLayer = window.dataLayer || []
  // IMPORTANTE: debe ser function clásica usando `arguments` (no arrow ni rest params).
  // gtag.js reconoce en el dataLayer solo objetos Arguments nativos, no arrays.
   
  function gtag() { window.dataLayer.push(arguments) }
  window.gtag = gtag

  gtag('consent', 'default', {
    analytics_storage: 'granted',
    ad_storage: 'denied',
    ad_user_data: 'denied',
    ad_personalization: 'denied',
  })

  gtag('js', new Date())

  // Encolamos config ANTES de que cargue gtag.js (patrón oficial),
  // pero también lo reaplicamos en onload para asegurarnos de que `transport_url`
  // se procese (hay casos donde no “engancha” si solo va encolado).
  applyConfig()
}

function loadGtagScript() {
  if (!MEASUREMENT_ID || typeof document === 'undefined') return

  // Evita inyectar el script varias veces (p.ej. banner de cookies + main).
  if (document.querySelector(`script[src^="https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}"]`)) {
    return
  }

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`
  script.onload = () => {
    // Reaplica config una vez cargado el runtime de gtag.
    applyConfig()
    // Fuerza un page_view explícito para que exista un hit real y sea visible en Network/Realtime.
    try {
      const loc = window.location.href
      window.gtag('event', 'page_view', {
        page_location: loc,
        page_path: window.location.pathname + window.location.search,
        page_title: document?.title || '',
      })
    } catch {
      // noop
    }
  }
  document.head.appendChild(script)
}

export function loadAnalytics() {
  if (!MEASUREMENT_ID) return
  initAnalytics()
  loadGtagScript()
}
